
import { useState } from 'react';
import { Button } from '@/components/base/buttons/button';
import { Input } from '@/components/base/input/input';


const SUPPORT_EMAIL = 'support@kordbooks.com';

export default function SupportPage() {
    const [copied, setCopied] = useState(false);

    const handleCopyEmail = async () => {
        try {
            if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                await navigator.clipboard.writeText(SUPPORT_EMAIL);
            } else {
                // Fallback for older browsers
                const textarea = document.createElement('textarea');
                textarea.value = SUPPORT_EMAIL;
                textarea.style.position = 'fixed';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy support email:', error);
        }
    };

    return (
        <div className="flex flex-col gap-8 max-w-3xl mx-auto py-10">
            {/* Page Header */}
            <div>
                <h1 className="text-display-sm font-semibold text-primary md:text-display-md">
                    Support
                </h1>
                <p className="mt-2 text-sm text-tertiary">
                    Get help or let us know any feedback.
                </p>
            </div>

            {/* Support Section */}
            <section className="space-y-4">
                <div>
                    <h2 className="text-lg font-medium text-primary">Contact Support</h2>
                    <p className="text-sm text-tertiary">
                        If you have any issues or questions, please reach out to our support team.
                    </p>
                </div>

                <div className="p-6 rounded-xl border border-secondary bg-primary max-w-md">
                    <div className="space-y-4">
                        <label className="block text-sm font-medium text-primary">
                            Support Email
                        </label>
                        <div className="flex items-center gap-3">
                            <Input
                                isDisabled={true}
                                value={SUPPORT_EMAIL}
                                className="bg-secondary/50 text-tertiary font-mono"
                            />
                            <Button onClick={handleCopyEmail} size="md">
                                {copied ? 'Copied!' : 'Copy'}
                            </Button>
                        </div>
                        {copied && (
                            <div className="text-xs text-success-primary mt-2">
                                Support email copied to your clipboard
                            </div>
                        )}
                        <p className="text-xs text-tertiary mt-2">
                            Our team will get back to you as soon as possible.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}